import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { generateValidationSchema } from "./Validations";
import { useFormik } from "formik";
import { useAddClinicMutation, useLazyGetclinicQuery } from "../State/Api/AddClinicInfoApiSlice";
import { useLocation, useNavigate } from "react-router-dom";

import { DatePicker } from "rsuite";
import PhoneInput from "react-phone-input-2";

function Registration() {
  const [selectedFile, setSelectedFile] = useState(null);
  const roleId = Number(localStorage.getItem("roleid"));
  const userUniqueId = localStorage.getItem("userUniqueID");

  const handleImageChange1 = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-CA");
  };
  const params = useLocation();
 
  const clinicId = params?.state?.id;
 
  const [image, setImage] = useState("/Images/Photo.svg");
  const [imageFile, setImageFile] = useState(null);
  const navigate = useNavigate();
  const [inviteClinic, { isSuccess, isError, isLoading, error }] =
    useAddClinicMutation();
  const [fetchClinic, { data: clinicData, isFetching, failed }] =
    useLazyGetclinicQuery();

  useEffect(() => {
    if (clinicId) {
      fetchClinic(clinicId);
    }
  }, [clinicId]);

  const formFields = [
    "email",
    "Clinic_Hospital_Name",
    "Clinic_Hospital_ID",
    "roleName",
    "phonenumber",
    "address",
    // "typeOfFacility",
    // "secondaryPhoneNumber",
    // "websiteURL",
    "addressLine2",
    "city",
    "state",
    "zipCode",
    "country",
    // "contactName",
    // "contactTitle",
    // "primaryContactPhoneNumber",
    // "secondaryContactPhoneNumber",
    // "contactEmailAddress",
    // "modules",
    // "subscriptionType",
    // "subscriptionStartDate",
    // "subscriptionEndDate",
    // "licenseNumberorAccreditationID",
    // "insuranceProvidersAssociated",
    // "taxIdentificationNumber_TIN",
    // "dateofEstablishment",
    // "emergencyContactInformation",
    // "specialRequirementsorNotes",
    // "preferredCommunicationMode",
    // "statusofModules",
    // "upgradeEligibility",
  ];
  const validationSchema = generateValidationSchema(formFields);
  const formik = useFormik({
    initialValues: {
      email: "",
      Clinic_Hospital_Name: "",
      Clinic_Hospital_ID: "",
      roleName: "",
      phonenumber: "",
      address: "",
      typeOfFacility: "",
      secondaryPhoneNumber: "",
      websiteURL: "",
      addressLine2: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
      contactName: "",
      contactTitle: "",
      primaryContactPhoneNumber: "",
      secondaryContactPhoneNumber: "",
      contactEmailAddress: "",
      modules: "",
      subscriptionType: "",
      subscriptionStartDate: "",
      subscriptionEndDate: "",
      licenseNumberorAccreditationID: "",
      insuranceProvidersAssociated: "",
      taxIdentificationNumber_TIN: "",
      dateofEstablishment: "",
      emergencyContactInformation: "",
      specialRequirementsorNotes: "",
      preferredCommunicationMode: "",
      statusofModules: "",
      upgradeEligibility: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => handleSubmit(values, { resetForm }),
  });

  useEffect(() => {
    if (clinicData) {
      formik.setValues({
        email: clinicData?.inviteUser?.email || "",
        Clinic_Hospital_Name:
          clinicData?.inviteUser?.clinic_Hospital_Name || "",
        Clinic_Hospital_ID: clinicData?.inviteUser?.clinic_Hospital_ID || "",
        roleName: clinicData?.inviteUser?.rolename || "",

        phonenumber: clinicData?.informationDetails?.primaryPhoneNumber || "",
        address: clinicData?.informationDetails?.addressLine1 || "",
        typeOfFacility: clinicData?.informationDetails?.typeofFacility || "",
        secondaryPhoneNumber:
          clinicData?.informationDetails?.secondaryPhoneNumber || "",
        websiteURL: clinicData?.informationDetails?.websiteURL || "",
        addressLine2: clinicData?.informationDetails?.addressLine2 || "",
        city: clinicData?.informationDetails?.city || "",
        state: clinicData?.informationDetails?.state || "",
        zipCode: clinicData?.informationDetails?.postal_ZIPCode || "",
        country: clinicData?.informationDetails?.country || "",

        contactName: clinicData?.contactDetails?.contactName || "",
        contactTitle: clinicData?.contactDetails?.contactDesignation || "",
        primaryContactPhoneNumber:
          clinicData?.contactDetails?.primaryContactPhoneNumber || "",
        secondaryContactPhoneNumber:
          clinicData?.contactDetails?.secondaryContactPhoneNumber || "",
        contactEmailAddress:
          clinicData?.contactDetails?.contactEmailAddress || "",

        modules: clinicData?.subscriptionDetails?.modules || "",
        subscriptionType:
          clinicData?.subscriptionDetails?.subscriptionType || "",
        subscriptionStartDate:
          formatDate(clinicData?.subscriptionDetails?.subscriptionStartDate) ||
          "",
        subscriptionEndDate:
          formatDate(clinicData?.subscriptionDetails?.subscriptionEndDate) ||
          "",

        licenseNumberorAccreditationID:
          clinicData?.complianceDetails?.licenseNumberorAccreditationID || "",
        insuranceProvidersAssociated:
          clinicData?.complianceDetails?.insuranceProvidersAssociated || "",
        taxIdentificationNumber_TIN:
          clinicData?.complianceDetails?.taxIdentificationNumber_TIN || "",
        dateofEstablishment:
          formatDate(clinicData?.complianceDetails?.dateofEstablishment) || "",

        emergencyContactInformation:
          clinicData?.additionalDetails?.emergencyContactInformation || "",
        specialRequirementsorNotes:
          clinicData?.additionalDetails?.specialRequirementsorNotes || "",
        preferredCommunicationMode:
          clinicData?.additionalDetails?.preferredCommunicationMode || "",

        statusofModules: clinicData?.masterAdminTracking?.statusofModules || "",
        upgradeEligibility:
          formatDate(clinicData?.masterAdminTracking?.upgradeEligibility) || "",
          clinicLogo : clinicData?.additionalDetails?.logoUpload
      });
      if (clinicData?.additionalDetails?.logoUpload) {
        setImage(clinicData?.additionalDetails?.logoUpload);
        setImageFile(clinicData?.additionalDetails?.logoUpload);
      }
    }
  }, [clinicData]);

  const isEditMode = Boolean(clinicId);

  const handleSubmit = async (values) => {
 
    const formdata = new FormData();
    formdata.append("inviteandbasicinfo.Email", values.email);
    formdata.append(
      "inviteandbasicinfo.Clinic_Hospital_Name",
      values.Clinic_Hospital_Name
    );
    formdata.append(
      "inviteandbasicinfo.Clinic_Hospital_ID",
      values.Clinic_Hospital_ID
    );
    formdata.append("inviteandbasicinfo.RoleName", values.roleName);

    formdata.append(
      "InformationDetails.PrimaryPhoneNumber",
      values.phonenumber
    );
    formdata.append(
      "InformationDetails.UserUniqueID",
      clinicData ? clinicId : "0"
    );
    formdata.append("InformationDetails.AddressLine1", values.address);
    formdata.append("InformationDetails.TypeofFacility", values.typeOfFacility);
    formdata.append(
      "InformationDetails.SecondaryPhoneNumber",
      values.secondaryPhoneNumber
    );
    formdata.append("InformationDetails.WebsiteURL", values.websiteURL);
    formdata.append("InformationDetails.AddressLine2", values.addressLine2);
    formdata.append("InformationDetails.City", values.city);
    formdata.append("InformationDetails.State", values.state);
    formdata.append("InformationDetails.Postal_ZIPCode", values.zipCode);
    formdata.append("InformationDetails.Country", values.country);

    formdata.append(
      "ContactDetails.UserUniqueID",
      clinicData ? clinicId : ""
    );
    formdata.append("ContactDetails.ContactName", values.contactName);
    formdata.append("ContactDetails.ContactDesignation", values.contactTitle);
    formdata.append(
      "ContactDetails.PrimaryContactPhoneNumber",
      values.primaryContactPhoneNumber
    );
    formdata.append(
      "ContactDetails.SecondaryContactPhoneNumber",
      values.secondaryContactPhoneNumber
    );
    formdata.append(
      "ContactDetails.ContactEmailAddress",
      values.contactEmailAddress
    );

    formdata.append(
      "SubscriptionDetails.UserUniqueID",
      clinicData ? clinicId : ""
    );
    formdata.append("SubscriptionDetails.Modules", values.modules);
    formdata.append(
      "SubscriptionDetails.SubscriptionType",
      values.subscriptionType
    );
    formdata.append(
      "SubscriptionDetails.SubscriptionStartDate",
      values.subscriptionStartDate
    );
    formdata.append(
      "SubscriptionDetails.SubscriptionEndDate",
      values.subscriptionEndDate
    );

    formdata.append(
      "complianceAndAccreditationDetails.UserUniqueID",
      clinicData ? clinicId : ""
    );
    formdata.append(
      "complianceAndAccreditationDetails.LicenseNumberorAccreditationID",
      values.licenseNumberorAccreditationID
    );
    formdata.append(
      "complianceAndAccreditationDetails.InsuranceProvidersAssociated",
      values.insuranceProvidersAssociated
    );
    formdata.append(
      "complianceAndAccreditationDetails.TaxIdentificationNumber_TIN",
      values.taxIdentificationNumber_TIN
    );
    formdata.append(
      "complianceAndAccreditationDetails.DateofEstablishment",
      values.dateofEstablishment
    );

    formdata.append(
      "additionalDetails.UserUniqueID",
      clinicData ? clinicId : ""
    );
    formdata.append(
      "additionalDetails.EmergencyContactInformation",
      values.emergencyContactInformation
    );
    formdata.append(
      "additionalDetails.SpecialRequirementsorNotes",
      values.specialRequirementsorNotes
    );
    formdata.append(
      "additionalDetails.PreferredCommunicationMode",
      values.preferredCommunicationMode
    );
    formdata.append("additionalDetails.LogoUpload", selectedFile ? selectedFile : values.clinicLogo);
    formdata.append(
      "masterAdminTrackingDetails.UserUniqueID",
      clinicData ? clinicId : ""
    );
    formdata.append(
      "masterAdminTrackingDetails.StatusofModules",
      values.statusofModules
    );
    formdata.append(
      "masterAdminTrackingDetails.UpgradeEligibility",
      values.upgradeEligibility
    );

    for (let [key, value] of formdata.entries()) {
    
    }
    try {
      const result = await inviteClinic(formdata).unwrap();
  

      if (result?.result_Code === 100 || result?.result_Code === 200) {
   
        if (roleId === 2) {
          navigate("/ClinicProfile");
        } else {
          navigate("/Clinics");
        }
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
      setImageFile(file);
    }
  };

  const profilestyles = `
    .rs-input-group{
  border-radius: 8px;
  height: 40px;
  border-color:1px solid #e5e5ea;
  }
  `;
  return (
    <>
      <style>{profilestyles}</style>
      <main style={{ width: "100%", height: "100%" }}>
        <div className="row">
          <div className="col-12 mb-3">
            <h4 className="m-0 ml-2 fw-bold" style={{ color: "#000" }}>
              {clinicId ? "Update Details" : "Add Details"}
            </h4>
          </div>
        </div>

        <div className="row pb-5">
          <div
            className="p-2 rounded mb-5"
            style={{
              background: "#FFFFFF",
              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            }}
          >
            <form className="col-12 mb-3" onSubmit={formik.handleSubmit}>
              <div
                class="custom-tab-btn mb-3 mt-2"
                style={{ marginLeft: ".6rem" }}
              >
                BASIC INFORMATION
              </div>

              <div className="row">
                {[
  {
    label: "Clinic/Hospital Name",
    name: "Clinic_Hospital_Name",
    type: "text",
  },
  {
    label: "Clinic Identification Number",
    name: "Clinic_Hospital_ID",
    type: "text",
  },
  { label: "Primary Phone Number", name: "phonenumber", type: "phone" },
  { label: "Primary Email Address", name: "email", type: "text" },
  { label: "Secondary Phone Number", name: "secondaryPhoneNumber", type: "phone" },
  { label: "Website URL", name: "websiteURL", type: "text" },
].map((field, idx) => {
  const isReadOnlyField =
    isEditMode &&
    ["Clinic_Hospital_Name", "Clinic_Hospital_ID", "email"].includes(field.name);

  return (
    <div className="col-12 col-md-6 col-lg-4 mb-3" key={idx}>
      <Form.Group controlId={field.name}>
        <Form.Label className="form-label-custom">
          {field.label} {field.name !== "websiteURL" && field.name !== "secondaryPhoneNumber" && <span className="text-danger">*</span>}
        </Form.Label>

        {/* 🔹 PhoneInput for phone fields */}
        {field.type === "phone" ? (
          <PhoneInput
            country="in"
            onlyCountries={["in"]}
            disableDropdown={true}
            countryCodeEditable={false}
            value={formik.values[field.name]}
            onChange={(value, country) => {
              // save both full number and dial code
              formik.setFieldValue(field.name, value);
              formik.setFieldValue(`${field.name}Code`, `+${country.dialCode}`);
            }}
            inputClass="form-control"
            specialLabel=""
            inputProps={{
              name: field.name,
              onBlur: formik.handleBlur,
            }}
          />
        ) : (
          <Form.Control
            type={field.type}
            name={field.name}
            placeholder={`Enter ${field.label}`}
            className="form-input-custom"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values[field.name]}
            disabled={isReadOnlyField}
          />
        )}

        {formik.touched[field.name] && formik.errors[field.name] && (
          <div className="form-error-text">{formik.errors[field.name]}</div>
        )}
      </Form.Group>
    </div>
  );
})}


                {/* Role Name */}
                <div className="col-12 col-md-6 col-lg-4 mb-3">
                  {" "}
                  {/* Changed col-xl-6 to col-xl-12 */}
                  <Form.Group controlId="roleName">
                    <Form.Label className="form-label-custom">
                      Role Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="roleName"
                      className="form-input-custom"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.roleName}
                      disabled={isEditMode}
                      style={{ width: "100% !important" }} // Optional if your CSS already handles it
                    >
                      <option value="" disabled hidden>
                        Select role
                      </option>
                      <option value="clinic">Clinic</option>
                      <option value="hospital">Hospital</option>
                      <option value="patient">Patient</option>
                      <option value="admin">Admin</option>
                    </Form.Select>
                    {formik.touched.roleName && formik.errors.roleName && (
                      <div className="form-error-text">
                        {formik.errors.roleName}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* Type of Facility */}
                <div className="col-12 col-md-6 col-lg-4 mb-3">
                  <Form.Group controlId="typeOfFacility">
                    <Form.Label className="form-label-custom">
                      Type of Facility
                    </Form.Label>
                    <Form.Select
                      name="typeOfFacility"
                      className="form-input-custom"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.typeOfFacility}
                      style={{ width: "100%" }} // Optional if already handled via CSS
                    >
                      <option value="" disabled hidden>
                        Select Facility
                      </option>
                      <option value="clinic">Clinic</option>
                      <option value="hospital">Hospital</option>
                      <option value="diagnosticCenter">
                        Diagnostic Center
                      </option>
                    </Form.Select>
                    {formik.touched.typeOfFacility &&
                      formik.errors.typeOfFacility && (
                        <div className="form-error-text">
                          {formik.errors.typeOfFacility}
                        </div>
                      )}
                  </Form.Group>
                </div>
              </div>
            </form>

            <div
              class="custom-tab-btn mb-3 mt-2 "
              style={{ marginLeft: ".6rem" }}
            >
              ADDRESS DETAILS
            </div>

            <div className="row">
              {[
                { label: "Address Line 1", name: "address" },
                { label: "Address Line 2", name: "addressLine2" },
                { label: "City", name: "city" },
                { label: "State/Province", name: "state" },
                { label: "Postal/ZIP Code", name: "zipCode" },
                { label: "Country", name: "country" },
              ].map((field, index) => (
                <div className="col-12 col-md-6 col-lg-4 mb-3" key={index}>
                  <Form.Group controlId={field.name}>
                    <Form.Label className="form-label-custom">
                      {field.label} <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name={field.name}
                      placeholder={`Enter ${field.label}`}
                      className="form-input-custom"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values[field.name]}
                    />
                    {formik.touched[field.name] &&
                      formik.errors[field.name] && (
                        <div className="form-error-text">
                          {formik.errors[field.name]}
                        </div>
                      )}
                  </Form.Group>
                </div>
              ))}
            </div>

            <div
              class="custom-tab-btn mb-3 mt-2 "
              style={{ marginLeft: ".6rem" }}
            >
              CONTACT PERSON DETAILS
            </div>

            <div className="row">
             {[
  {
    label: "Contact Name",
    name: "contactName",
    type: "text",
    placeholder: "Enter Contact Name",
  },
  {
    label: "Primary Contact Phone Number",
    name: "primaryContactPhoneNumber",
    type: "phone",
    placeholder: "Enter Primary Phone Number",
  },
  {
    label: "Secondary Contact Phone Number",
    name: "secondaryContactPhoneNumber",
    type: "phone",
    placeholder: "Enter Secondary Phone Number",
  },
  {
    label: "Contact Email Address",
    name: "contactEmailAddress",
    type: "email",
    placeholder: "Enter Email Address",
  },
].map((field, idx) => (
  <div className="col-12 col-md-6 col-lg-4 mb-3" key={idx}>
    <Form.Group controlId={field.name}>
      <Form.Label className="form-label-custom">
        {field.label} 
      </Form.Label>

      {/* 🔹 Use PhoneInput for phone fields */}
      {field.type === "phone" ? (
        <PhoneInput
          country="in"
          onlyCountries={["in"]}
          disableDropdown={true}
          countryCodeEditable={false}
          value={formik.values[field.name]}
          onChange={(value, country) => {
            formik.setFieldValue(field.name, value);
            formik.setFieldValue(`${field.name}Code`, `+${country.dialCode}`);
          }}
          inputClass="form-control"
          specialLabel=""
          inputProps={{
            name: field.name,
            onBlur: formik.handleBlur,
          }}
        />
      ) : (
        <Form.Control
  type={field.type}
  name={field.name}
  placeholder={field.placeholder}
  className="form-input-custom"
  onChange={(e) => {
    if (field.name === "contactName") {
      const lettersOnly = e.target.value.replace(/[^a-zA-Z\s]/g, "");
      formik.setFieldValue(field.name, lettersOnly);
    } else {
      formik.handleChange(e);
    }
  }}
  onBlur={formik.handleBlur}
  value={formik.values[field.name]}
/>
      )}

      {formik.touched[field.name] && formik.errors[field.name] && (
        <div className="form-error-text">{formik.errors[field.name]}</div>
      )}
    </Form.Group>
  </div>
))}


              {/* Select Field for Contact Title */}
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <Form.Group controlId="contactTitle">
                  <Form.Label className="form-label-custom">
                    Contact Title/Designation{" "}
                  </Form.Label>
                  <Form.Select
                    name="contactTitle"
                    className="form-input-custom"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.contactTitle}
                  >
                    <option value="" disabled hidden>
                      Select Title/Designation
                    </option>
                    <option value="headPractitioner">Head Practitioner</option>
                    <option value="Administrator">Administrator</option>
                  </Form.Select>
                  {formik.touched.contactTitle &&
                    formik.errors.contactTitle && (
                      <div className="form-error-text">
                        {formik.errors.contactTitle}
                      </div>
                    )}
                </Form.Group>
              </div>
            </div>

            <div
              class="custom-tab-btn mb-3 mt-2 "
              style={{ marginLeft: ".6rem" }}
            >
              Subscription Details
            </div>

            <div className="row">
              {/* Modules/Sub-Modules Requested */}
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <Form.Group controlId="modules">
                  <Form.Label className="form-label-custom">
                    Modules/Sub-Modules Requested{" "}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="modules"
                    className="form-input-custom"
                    placeholder="Enter requested modules"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.modules}
                  />
                  {formik.touched.modules && formik.errors.modules && (
                    <div className="form-error-text">
                      {formik.errors.modules}
                    </div>
                  )}
                </Form.Group>
              </div>

              {/* Subscription Type */}
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <Form.Group controlId="subscriptionType">
                  <Form.Label className="form-label-custom">
                    Subscription Type
                  </Form.Label>
                  <Form.Select
                    name="subscriptionType"
                    className="form-input-custom"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.subscriptionType}
                  >
                    <option value="" disabled hidden>
                      Select
                    </option>
                    <option value="basic">Basic</option>
                    <option value="premium">Premium</option>
                    <option value="enterprise">Enterprise</option>
                  </Form.Select>
                  {formik.touched.subscriptionType &&
                    formik.errors.subscriptionType && (
                      <div className="form-error-text">
                        {formik.errors.subscriptionType}
                      </div>
                    )}
                </Form.Group>
              </div>

              {/* Subscription Start Date */}
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <Form.Group controlId="subscriptionStartDate">
                  <Form.Label className="form-label-custom">
                    Subscription Start Date{" "}
                   
                  </Form.Label>
                  {/* <Form.Control
                    type="date"
                    name="subscriptionStartDate"
                    className="form-input-custom"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.subscriptionStartDate}
                  /> */}
                  <DatePicker
                    name="subscriptionStartDate"
                    value={
                      formik.values.subscriptionStartDate
                        ? new Date(formik.values.subscriptionStartDate)
                        : null
                    }
                    onChange={(value) => {
  formik.setFieldValue(
    "subscriptionStartDate",
    value ? value.toLocaleDateString("en-CA") : ""
  );
}}

                    onBlur={() =>
                      formik.setFieldTouched("subscriptionStartDate", true)
                    }
                    format="dd-MMM-yyyy"
                    placeholder="dd-mmm-yyyy"
                    oneTap
                    style={{ width: "100%" }}
                    className="custom-datepicker"
                  />
                  {formik.touched.subscriptionStartDate &&
                    formik.errors.subscriptionStartDate && (
                      <div className="form-error-text">
                        {formik.errors.subscriptionStartDate}
                      </div>
                    )}
                </Form.Group>
              </div>

              {/* Subscription End Date */}
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <Form.Group controlId="subscriptionEndDate">
                  <Form.Label className="form-label-custom">
                    Subscription End Date 
                  </Form.Label>
                  <DatePicker
                    name="subscriptionEndDate"
                    format="dd-MMM-yyyy"
                    placeholder="dd-MMM-yyyy"
                    oneTap
                    style={{ width: "100%" }}
                    value={
                      formik.values.subscriptionEndDate
                        ? new Date(formik.values.subscriptionEndDate)
                        : null
                    }
                    onChange={(value) => {
  const formattedDate = value
    ? value.toLocaleDateString("en-CA")
    : "";
  formik.setFieldValue("subscriptionEndDate", formattedDate);
}}

                    onBlur={() =>
                      formik.setFieldTouched("subscriptionEndDate", true)
                    }
                    className="custom-datepicker"
                  />
                  {formik.touched.subscriptionEndDate &&
                    formik.errors.subscriptionEndDate && (
                      <div className="form-error-text">
                        {formik.errors.subscriptionEndDate}
                      </div>
                    )}
                </Form.Group>
              </div>
            </div>

            <div
              class="custom-tab-btn mb-3 mt-2 "
              style={{ marginLeft: ".6rem" }}
            >
              Compliance and Accreditation
            </div>

            <div className="row">
              {/* License Number or Accreditation ID */}
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <Form.Group controlId="licenseNumberorAccreditationID">
                  <Form.Label className="form-label-custom">
                    License Number or Accreditation ID{" "}
                    
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="licenseNumberorAccreditationID"
                    className="form-input-custom"
                    placeholder="Enter License/Accreditation ID"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.licenseNumberorAccreditationID}
                  />
                  {formik.touched.licenseNumberorAccreditationID &&
                    formik.errors.licenseNumberorAccreditationID && (
                      <div className="form-error-text">
                        {formik.errors.licenseNumberorAccreditationID}
                      </div>
                    )}
                </Form.Group>
              </div>

              {/* Insurance Providers Associated */}
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <Form.Group controlId="insuranceProvidersAssociated">
                  <Form.Label className="form-label-custom">
                    Insurance Providers Associated{" "}
                   
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="insuranceProvidersAssociated"
                    className="form-input-custom"
                    placeholder="Enter Insurance Providers"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.insuranceProvidersAssociated}
                  />
                  {formik.touched.insuranceProvidersAssociated &&
                    formik.errors.insuranceProvidersAssociated && (
                      <div className="form-error-text">
                        {formik.errors.insuranceProvidersAssociated}
                      </div>
                    )}
                </Form.Group>
              </div>

              {/* Tax Identification Number (TIN) */}
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <Form.Group controlId="taxIdentificationNumber_TIN">
                  <Form.Label className="form-label-custom">
                    Tax Identification Number (TIN){" "}
                   
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="taxIdentificationNumber_TIN"
                    className="form-input-custom"
                    placeholder="Enter TIN"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.taxIdentificationNumber_TIN}
                  />
                  {formik.touched.taxIdentificationNumber_TIN &&
                    formik.errors.taxIdentificationNumber_TIN && (
                      <div className="form-error-text">
                        {formik.errors.taxIdentificationNumber_TIN}
                      </div>
                    )}
                </Form.Group>
              </div>

              {/* Date of Establishment */}
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <Form.Group controlId="dateofEstablishment">
                  <Form.Label className="form-label-custom">
                    Date of Establishment 
                  </Form.Label>
                  <DatePicker
                    name="dateofEstablishment"
                    format="dd-MMM-yyyy"
                    placeholder="dd-MMM-yyyy"
                    oneTap
                    style={{ width: "100%" }}
                    value={
                      formik.values.dateofEstablishment
                        ? new Date(formik.values.dateofEstablishment)
                        : null
                    }
                    onChange={(value) => {
                      const formattedDate =
                        value?.toISOString().split("T")[0] || "";
                      formik.setFieldValue(
                        "dateofEstablishment",
                        formattedDate
                      );
                    }}
                    onBlur={() =>
                      formik.setFieldTouched("dateofEstablishment", true)
                    }
                    className="custom-datepicker"
                  />
                  {formik.touched.dateofEstablishment &&
                    formik.errors.dateofEstablishment && (
                      <div className="form-error-text">
                        {formik.errors.dateofEstablishment}
                      </div>
                    )}
                </Form.Group>
              </div>
            </div>

            <div
              class="custom-tab-btn mb-3 mt-2 "
              style={{ marginLeft: ".6rem" }}
            >
              Additional Details
            </div>

            <div className="row">
              {/* Emergency Contact Information */}
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <Form.Group controlId="emergencyContactInformation">
                  <Form.Label className="form-label-custom">
                    Emergency Contact Information{" "}
                   
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="emergencyContactInformation"
                    className="form-input-custom"
                    placeholder="Enter Emergency Contact"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.emergencyContactInformation}
                  />
                  {formik.touched.emergencyContactInformation &&
                    formik.errors.emergencyContactInformation && (
                      <div className="form-error-text">
                        {formik.errors.emergencyContactInformation}
                      </div>
                    )}
                </Form.Group>
              </div>

              {/* Special Requirements or Notes */}
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <Form.Group controlId="specialRequirementsorNotes">
                  <Form.Label className="form-label-custom">
                    Special Requirements or Notes
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="specialRequirementsorNotes"
                    className="form-input-custom"
                    placeholder="Enter any notes or special needs"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.specialRequirementsorNotes}
                  />
                  {formik.touched.specialRequirementsorNotes &&
                    formik.errors.specialRequirementsorNotes && (
                      <div className="form-error-text">
                        {formik.errors.specialRequirementsorNotes}
                      </div>
                    )}
                </Form.Group>
              </div>

              {/* Preferred Communication Mode */}
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <Form.Group controlId="preferredCommunicationMode">
                  <Form.Label className="form-label-custom">
                    Preferred Communication Mode{" "}
                   
                  </Form.Label>
                  <Form.Select
                    name="preferredCommunicationMode"
                    className="form-input-custom"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.preferredCommunicationMode}
                  >
                    <option value="" disabled hidden>
                      Select
                    </option>
                    <option value="phone">Phone</option>
                    <option value="email">Email</option>
                    <option value="messaging">Messaging</option>
                  </Form.Select>
                  {formik.touched.preferredCommunicationMode &&
                    formik.errors.preferredCommunicationMode && (
                      <div className="form-error-text">
                        {formik.errors.preferredCommunicationMode}
                      </div>
                    )}
                </Form.Group>
              </div>

              {/* Logo Upload */}
              <div className="col-12 mb-3">
                <Form.Group controlId="logoUpload">
                  <Form.Label className="form-label-custom mb-1">
                    Logo Upload
                    <div style={{ fontSize: "0.75rem", color: "grey" }}>
                      (optional, for branding purposes)
                    </div>
                  </Form.Label>

                  {/* Browse Button */}
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <label
                      htmlFor="file-upload"
                      className="btn btn-outline-primary d-flex align-items-center"
                    >
                      <i className="bi bi-upload"></i>{" "}
                      {/* Bootstrap Icon - upload */}
                      Logo Upload
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      className="d-none w-100"
                      onChange={handleImageChange1}
                    />
                  </div>

                  {/* File Preview */}
                  {selectedFile && (
                    <div className="d-flex justify-content-between align-items-center px-3 py-2 border rounded bg-white">
                      <div style={{ fontSize: "0.9rem" }}>
                        {selectedFile.name}{" "}
                        <span
                          className="text-muted"
                          style={{ fontSize: "0.8rem" }}
                        >
                          {" "}
                          {Math.round(selectedFile.size / 1024)} KB
                        </span>
                      </div>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setSelectedFile(null)}
                        aria-label="Remove file"
                      ></button>
                    </div>
                  )}
                </Form.Group>
              </div>
            </div>

            <div
              class="custom-tab-btn mb-3 mt-2 "
              style={{ marginLeft: ".6rem" }}
            >
              For Master Admin Tracking
            </div>

            <div className="row">
              {/* Status of Modules */}
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <Form.Group controlId="statusofModules">
                  <Form.Label className="form-label-custom">
                    Status of Modules 
                  </Form.Label>
                  <Form.Select
                    name="statusofModules"
                    className="form-input-custom"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.statusofModules}
                  >
                    <option value="" disabled hidden>
                      Select
                    </option>
                    <option value="active">Active</option>
                    <option value="requested">Requested</option>
                    <option value="pending">Pending</option>
                  </Form.Select>
                  {formik.touched.statusofModules &&
                    formik.errors.statusofModules && (
                      <div className="form-error-text">
                        {formik.errors.statusofModules}
                      </div>
                    )}
                </Form.Group>
              </div>

              {/* Upgrade Eligibility */}
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <Form.Group controlId="upgradeEligibility">
                  <Form.Label className="form-label-custom">
                    Upgrade Eligibility
                    <br />
                    {/* <span style={{ fontSize: "0.6rem", color: "grey" }}>
                      (Date when the Clinic can upgrade modules)
                    </span> */}
                  </Form.Label>
                  <DatePicker
                    name="upgradeEligibility"
                    format="dd-MMM-yyyy"
                    placeholder="dd-MMM-yyyy"
                    oneTap
                    style={{ width: "100%" }}
                    value={
                      formik.values.upgradeEligibility
                        ? new Date(formik.values.upgradeEligibility)
                        : null
                    }
                    onChange={(value) => {
                      const formattedDate =
                        value?.toISOString().split("T")[0] || "";
                      formik.setFieldValue("upgradeEligibility", formattedDate);
                    }}
                    onBlur={() =>
                      formik.setFieldTouched("upgradeEligibility", true)
                    }
                    className="custom-datepicker"
                  />
                  {formik.touched.upgradeEligibility &&
                    formik.errors.upgradeEligibility && (
                      <div className="form-error-text">
                        {formik.errors.upgradeEligibility}
                      </div>
                    )}
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-12 mb-3">
                <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                  <p
                    className="mb-0"
                    style={{ fontSize: "0.8rem", color: "#6E7680" }}
                  >
                    Note
                    <br />* mark indicates that the field is optional.
                  </p>

                  <div className="d-flex gap-3">
                    <button onClick={()=>navigate(-1)} className="btn-back shadow-sm" type="button">
                      Cancel
                    </button>

                    <button
                      className="gradient-button"
                      type="button"
                      onClick={formik.handleSubmit}
                    >
                      {clinicId ? "Update" : "Save"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default Registration;
